import { render, staticRenderFns } from "./ResourceItem.vue?vue&type=template&id=ffda9dd4&scoped=true&"
import script from "./ResourceItem.vue?vue&type=script&lang=js&"
export * from "./ResourceItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffda9dd4",
  null
  
)

export default component.exports